import { render, staticRenderFns } from "./CustomerHelpTable.vue?vue&type=template&id=0f5df4ac&scoped=true&"
import script from "./CustomerHelpTable.vue?vue&type=script&lang=js&"
export * from "./CustomerHelpTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHelpTable.vue?vue&type=style&index=0&id=0f5df4ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5df4ac",
  null
  
)

export default component.exports